<div class="div-info">
  {{'Reporting.Info' | translate}}
</div>


<mat-form-field appearance="fill" class="form-field" floatLabel="always">
  <mat-label>{{'Reporting.Title' | translate}}</mat-label>
  <mat-select [(ngModel)]="reportType" placeholder="{{'RequiredPlaceholderSelect' | translate}}">
    <mat-option [value]="0">{{'Reporting.Einbringlichkeit' | translate}}</mat-option>
  </mat-select>
</mat-form-field>

<mat-form-field appearance="fill" floatLabel="always" class="form-field">
  <mat-label>{{'Von' | translate}}</mat-label>

  <input matInput style="margin: 0px" [ngModel]="dateVon | date:'dd.MM.yyyy'"
    (ngModelChange)="dateVon=this.oroservice.ChangeDate($event);" autocomplete='off'>
    <input type="hidden" [matDatepicker]="pickerVon" [(ngModel)]='dateVon'>

    <mat-datepicker-toggle matSuffix [for]="pickerVon" tabindex="-1"></mat-datepicker-toggle>
    <mat-datepicker #pickerVon></mat-datepicker>
  </mat-form-field>

  <mat-form-field appearance="fill" class="form-field" floatLabel="always">
    <mat-label>{{'Bis' | translate}}</mat-label>

    <input matInput style="margin: 0px" [ngModel]="dateBis | date:'dd.MM.yyyy'"
      (ngModelChange)="dateBis=this.oroservice.ChangeDate($event);" autocomplete='off'>
      <input type="hidden" [matDatepicker]="pickerBis" [(ngModel)]='dateBis'>

      <mat-datepicker-toggle matSuffix [for]="pickerBis" tabindex="-1"></mat-datepicker-toggle>
      <mat-datepicker #pickerBis></mat-datepicker>
    </mat-form-field>

    <button mat-flat-button (click)="downloadReport()" color="primary" class="button-custom" [disabled]="!canSubmit()">
      <mat-icon>get_app</mat-icon>&nbsp;
      {{'Reporting.Download' | translate}}
    </button>

    @if (isDateFuture(this.dateVon) || isDateFuture(this.dateBis)) {
      <div class="row no-padding">
        <mat-error>{{'Reporting.ErrorFuture' | translate}}</mat-error>
      </div>
    }